export default __webpack_public_path__ + "static/media/xclaim_money.46b22101.svg";